/**
 * Default configuration for ModelViewer.
 * Every prop is optional; missing props fall back to these values.
 */
export const DEFAULTS = {
  // Model
  modelUrl: '/hamburger.glb',

  // Camera
  cameraType: 'perspective',       // 'perspective' | 'orthographic'
  cameraPosition: [3, 2, 5],
  fov: 45,                         // degrees (perspective only)

  // OrbitControls
  autoRotate: true,
  autoRotateSpeed: 0.5,
  enableZoom: true,
  enablePan: false,
  enableRotate: true,
  minDistance: 2,
  maxDistance: 40,
  minPolarAngle: Math.PI / 6,      // 30°
  maxPolarAngle: Math.PI / 2.5,    // ~72°

  // Scene
  // backgroundColor: '#fffff',
  shadows: true,
  environment: null,               // null | 'city'|'studio'|'warehouse'|'sunset'|'night'

  // Lights (used when environment is null)
  ambientIntensity: 0.8,
  directionalIntensity: 3,
  pointIntensity: 2,

  // Model transform
  fitToView: true,
  centerModel: true,
  scale: 1,

  // Visual helpers
  showGrid: false,
  showAxes: false,
  wireframe: false,

  // Callbacks & slots
  loadingComponent: null,          // ReactNode shown while loading
  onModelLoad: null,               // (scene: Object3D) => void
  onError: null,                   // (error: Error) => void
};
